<div class="custom-container">
  <div class="title-container">
    <h2 class="title">
      {{ 'Reports.Title' | translate }}
    </h2>
    <hr class="separation-line" />
  </div>

  <section class="filters-container">
    <label class="label">
      <i class="fas fa-search"></i>
      {{'Reports.Filters.Title' | translate}}
    </label>
    <div>
      <div class="filters-container-sub">
        <custom-select placeholderTranslationTag="Reports.Filters.ActiveOrClosed" [options]="activeOrClosed"
          [clearEnabled]="true" [(selectedKey)]="searchOptions.activeOrClosed"></custom-select>
        <custom-select placeholderTranslationTag="Reports.Filters.CompanyOrPeson" [options]="companyOrPerson"
          [clearEnabled]="true" [(selectedKey)]="searchOptions.isPerson"></custom-select>
        <custom-multi-select placeholderTranslationTag="Reports.Filters.CaseStage" [options]="caseRoles"
          [clearEnabled]="true" [(selectedKeys)]="searchOptions.roleNames"></custom-multi-select>
        <custom-select placeholderTranslationTag="Reports.Filters.CaseStatus" [options]="caseStatuses$ | async"
          [clearEnabled]="true" [(selectedKey)]="searchOptions.statusGroupId"></custom-select>
        <custom-select placeholderTranslationTag="Reports.Filters.FlaggedCase" [options]="flagged" [clearEnabled]="true"
          [(selectedKey)]="searchOptions.isFlagged"></custom-select>
        <p-datepicker placeholder="{{'Reports.Filters.RegisteredDateFrom' | translate}}"
          [ngModel]="searchOptions.registeredDateFrom | jsonDateParse"
          (ngModelChange)="searchOptions.registeredDateFrom = $event"></p-datepicker>
        <p-datepicker placeholder="{{'Reports.Filters.ClosedDateFrom' | translate}}"
          [ngModel]="searchOptions.closedDateFrom | jsonDateParse"
          (ngModelChange)="searchOptions.closedDateFrom = $event"></p-datepicker>
        <p-datepicker placeholder="{{'Reports.Filters.TransferredToSurveillanceFrom' | translate}}"
          [ngModel]="searchOptions.transferredDateToLtsFrom | jsonDateParse"
          (ngModelChange)="searchOptions.transferredDateToLtsFrom = $event"></p-datepicker>
        <custom-multi-select placeholderTranslationTag="Reports.Filters.OriginalCustomer" [options]="originalCustomers$ | async"
          [clearEnabled]="true" [searchEnabled]="true" [(selectedKeys)]="searchOptions.originalCustomers">
        </custom-multi-select>
      </div>
      <div class="filters-container-sub">
        <input type="text" class="text-input" placeholder="{{'Reports.Filters.Reference' | translate}} 1"
          [(ngModel)]="searchOptions.reference1">
        <input type="text" class="text-input" placeholder="{{'Reports.Filters.Reference' | translate}} 2"
          [(ngModel)]="searchOptions.reference2">
        <input type="text" class="text-input" placeholder="{{'Reports.Filters.Reference' | translate}} 3"
          [(ngModel)]="searchOptions.reference3">
        <custom-select placeholderTranslationTag="Reports.Filters.UntreatedTasks" [options]="untreatedTasks"
          [clearEnabled]="true" [(selectedKey)]="searchOptions.hasUntreatedMessages"></custom-select>
        <custom-multi-select placeholderTranslationTag="Reports.Filters.CustomerNumber" [options]="customers$ | async"
          [clearEnabled]="true" [searchEnabled]="true"
          [(selectedKeys)]="searchOptions.customerNumbers"></custom-multi-select>
        <p-datepicker placeholder="{{'Reports.Filters.RegisteredDateTo' | translate}}"
          [ngModel]="searchOptions.registeredDateTo | jsonDateParse"
          (ngModelChange)="searchOptions.registeredDateTo = $event"></p-datepicker>
        <p-datepicker placeholder="{{'Reports.Filters.ClosedDateTo' | translate}}"
          [(ngModel)]="searchOptions.closedDateTo" (ngModelChange)="searchOptions.closedDateTo = $event"></p-datepicker>
        <p-datepicker placeholder="{{'Reports.Filters.TransferredToSurveillanceTo' | translate}}"
          [ngModel]="searchOptions.transferredDateToLtsTo | jsonDateParse"
          (ngModelChange)="searchOptions.transferredDateToLtsTo = $event"></p-datepicker>
        <input type="text" class="text-input" placeholder="{{'Reports.Filters.InvoiceNumber' | translate}}"
          [(ngModel)]="searchOptions.invoiceNumber">
      </div>
    </div>
  </section>

  <section class="columns-container">
    <fieldset class="custom-checkbox-container">
      <input type="checkbox" [checked]="true" disabled>
      <span class="checkmark"></span>
      <label class="label">
        {{'Reports.Columns.Title' | translate}}
      </label>
    </fieldset>
    <div>
      <div class="columns-container-sub">
        <label *ngFor="let column of searchColumns() | slice:0:searchColumnsSplitIndex() "
          class="custom-checkbox-container">
          <input type="checkbox" [id]="column.name" (change)="onChooseColumn($event.target.checked, column)"
            class="column-checkbox" [checked]="searchOptions?.caseSearchColumns?.includes(column.name)">
          <span class="checkmark"></span>
          <label class="label" [for]="column.name">
            {{ 'Reports.Columns.' + column.name | translate }}
          </label>
        </label>
      </div>

      <div class="columns-container-sub">
        <label *ngFor="let column of searchColumns() | slice:searchColumnsSplitIndex() : ((searchColumns()?.length ?? 1) - 1)"
          class="custom-checkbox-container">
          <input type="checkbox" [id]="column.name" (change)="onChooseColumn($event.target.checked, column)"
            class="column-checkbox" [checked]="searchOptions?.caseSearchColumns?.includes(column.name)">
          <span class="checkmark"></span>
          <label class="label" [for]="column.name">
            {{ 'Reports.Columns.' + column.name | translate }}
          </label>
        </label>
      </div>
    </div>
  </section>

  <section class="saved-container">
    <div class="title-container">
      <h3 class="title">
        {{ 'Reports.MyReports' | translate }}
      </h3>
      <hr class="separation-line" />
    </div>

    <app-saved-searches #savedSearchesComponent [savedSearches]="savedSearches"
      (selectedSavedSearchChange)="onSelectSavedSearch($event)" (saveSearch)="onSaveSearch($event)"
      (deleteSearch)="onDeleteSearch($event)">
    </app-saved-searches>
  </section>

  <section class="reports-container">
    <div class="title-container">
      <h3 class="title">
        {{ 'Reports.StandardReports' | translate }}
      </h3>
      <hr class="separation-line" />
    </div>

    <ul>
      <li *ngFor="let menuItem of filteredMenu$ | async" class="menu-item">
        <a [routerLink]="menuItem.link" [id]="menuItem.id">
          {{menuItem.translationTag | translate}}
        </a>
      </li>
    </ul>
  </section>

  <section class="options-container">
    <button type="button" class="button-update" (click)="onEmptySelection()">
      {{ 'Reports.Options.EmptySelection' | translate }}
    </button>
    <button type="button" class="button-basic-reverse" (click)="onClickSaveSearch()">
      {{ 'Reports.Options.SaveReport' | translate }}
    </button>
    <button type="button" class="button-basic" (click)="onGenerateReport()">
      {{ 'Reports.Options.GenerateReport' | translate }}
    </button>
  </section>

  <section *ngIf="showResults" class="results-container">
    <app-custom-case-list #ListComponenent [columns]="customCaseListColumns" [paginatedList]="searchResults$ | async"
      [isLoading]="showLoading" [numberOfItemsPerPage]="pageSize" [pageNumber]="currentPage"
      [localizationSettings]="localizationSettings$ | async" (selectedPageNumber)="onSelectedPageChange($event)"
      (numberOfItemsPerPageChange)="onNumberOfItemsPerPageChange($event)" (onExportExcelClick)="onExportExcelClick()"
      (selectedCase)="onCaseSelected($event, ListComponenent.paginatedList)">
    </app-custom-case-list>
  </section>
</div>